import { combineReducers } from 'redux'
import globalReducer from './reducer'

export default combineReducers({
  globalReducer,
});